import styled from 'styled-components';

export const CardTitle = styled.span`
    font-size: 12px;
    color: #8C8C8C;
    font-weight: 600;
`;

export const CardData = styled.div`
    font-size: 30px;
    font-weight: 700;
    line-height: 30px;
`;

export const IconArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    height: 48px;
    width: 48px;
    background-color: #001529;
`;